import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(Vant)

// Set API Base URL
// In production, Nginx proxies /api to backend. In dev, we can point to localhost:3000 or use proxyTable.
// Better strategy: Use /api everywhere and configure devServer proxy in vue.config.js for local dev.
// But for now, let's switch based on env.
if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = '/api';
} else {
    axios.defaults.baseURL = 'http://localhost:3000/api';
}

Vue.prototype.$http = axios

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
